// DS5.7
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { URLS, Url } from '@wix/da-url';
import { ThemeContext, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import AddIcon from '@wix/da-ds/pkg/Icons/16x16/Add';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Logo from '@wix/da-ds/pkg/Logo';
import { useRestrictToLoggedIn } from '../utils/hooks/useRestrictToLoggedIn';
import { useWatchButton } from '../WatchButton/useWatchButton';
import FooterCopyright from './FooterCopyright';
import { menuItems, socialButtons } from './constants';
import s from './SiteFooter.scss';
const TEAM_USER = {
    userId: 47880507,
    useridUuid: 'eae614f8-f83b-4837-935b-ab22f4298eb2',
    username: 'team',
    type: 'admin'
};
const SiteFooter = ({ className })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const theme = useContext(ThemeContext);
    const isDarkTheme = theme === ThemeOptions.DARK;
    const numLinkColumns = isMobile ? 2 : 3;
    // might want to make this 3 on ultra-wide (500+) mobile
    const linksPerColumn = Math.ceil(menuItems.length / numLinkColumns);
    const linkColumns = [];
    for(let i = 0; i < menuItems.length; i += linksPerColumn){
        linkColumns.push(menuItems.slice(i, i + linksPerColumn));
    }
    const { restrictToLoggedIn } = useRestrictToLoggedIn();
    const onSuccessfulWatch = (isWatching)=>{
        if (isWatching && typeof window !== 'undefined') {
            window.location.assign(Url.userLink(TEAM_USER.username));
        }
    };
    const { onClick: onWatch, biData } = useWatchButton(TEAM_USER, false, false, false, onSuccessfulWatch, false, {
        evid: 380,
        sectionname: 'siteFooter'
    } // WatchAuthorBiEvent
    );
    const onClickWatch = restrictToLoggedIn(ReferralType.SITE_FOOTER, onWatch);
    return /*#__PURE__*/ React.createElement("footer", {
        className: classnames(s['root'], className),
        role: "contentinfo"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['main-content']
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['column'], s['left'])
    }, /*#__PURE__*/ React.createElement(BiLink, {
        href: URLS.ROOT,
        title: "DeviantArt - Homepage",
        biData: BiData({
            evid: 720,
            link_name: 'logo'
        })
    }, /*#__PURE__*/ React.createElement(VisuallyHidden, null, "DeviantArt - Homepage"), /*#__PURE__*/ React.createElement(Logo, {
        markColor: isDarkTheme ? 'white' : 'black',
        textColor: isDarkTheme ? 'white' : 'black',
        size: "tiny"
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['social']
    }, socialButtons.map((sb, index)=>/*#__PURE__*/ React.createElement(BiLink, {
            key: sb.title,
            href: sb.href,
            title: sb.title,
            biData: BiData({
                evid: 720,
                link_name: sb.name
            })
        }, /*#__PURE__*/ React.createElement(VisuallyHidden, null, sb.title), /*#__PURE__*/ React.createElement(sb.icon, {
            size: IconSize.MEDIUM,
            disableDefaultColors: true
        }))))), linkColumns.map((columnItems, i)=>/*#__PURE__*/ React.createElement("div", {
            key: `column-${i}`,
            className: s['column']
        }, columnItems.map((item)=>/*#__PURE__*/ React.createElement(BiLink, {
                key: item.key,
                className: s['link'],
                href: item.href,
                title: t(item.key),
                biData: BiData({
                    evid: 720,
                    link_name: item.name
                })
            }, t(item.mobileKey && isMobile ? item.mobileKey : item.key))))), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['column'], s['right'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['watch-team-description']
    }, t('siteFooter.watchTeam.description', {
        postProcess: 'reactPostprocessor',
        daTeamProfile: /*#__PURE__*/ React.createElement("a", {
            href: Url.userLink(TEAM_USER.username)
        }, "DA Team profile")
    })), /*#__PURE__*/ React.createElement(BrandedButton, {
        size: "small",
        variant: "brand-green",
        icon: AddIcon,
        biData: biData,
        onClick: onClickWatch
    }, t('siteFooter.watchTeam.buttonText')))), /*#__PURE__*/ React.createElement(FooterCopyright, null));
};
SiteFooter.displayName = 'SiteFooter';
export default /*#__PURE__*/ React.memo(SiteFooter);
